import {
  LUX_PAGE_LABELS,
  LUX_USER_DATA,
  sendLuxUserData,
  setLuxPageLabel,
} from 'commons/lux';
import { useEffect } from 'react';

const usePDPLuxAnalytics = () => {
  useEffect(() => {
    setLuxPageLabel(LUX_PAGE_LABELS.PDPv2);
    sendLuxUserData(LUX_USER_DATA.PDP, 'v2');
    return () => setLuxPageLabel(LUX_PAGE_LABELS.UNSET);
  }, []);
};

export default usePDPLuxAnalytics;
